function initVeolia10km() {

    var VmapDiv = document.getElementById("Veolia-zone-map"); 	
  	if (!VmapDiv) {
    	return;
  	}
  
  var Vmap = new google.maps.Map(VmapDiv, {
		center: {lat: -27.5788, lng: 153.026},
		zoom: 11.5,
      	zoomControl: true         
	});  
 
  	
    var imageUrl = "https://cdn.shopify.com/s/files/1/1665/6197/files/Google_M_icon.png?1017007359068392630";
  
  	new google.maps.Marker({
    	position: new google.maps.LatLng(-27.565169, 153.000749),  
    	animation: google.maps.Animation.DROP,
     	title: 'Veolia',
     	label: 'V',
      	//icon: imageUrl,
    	map: Vmap
    });
  
  
  	var VeoliaCircle = new google.maps.Circle({
            strokeColor: '#000000',
            strokeOpacity: 0.2,
            strokeWeight: 1,
            fillColor: '#cc0000',
            fillOpacity: 0.13,
     		center: {lat: -27.565169, lng: 153.000749},
            radius: 10015,
      		id: "Reduced rates"
            //map: Vmap
      });
    
  
	/*var Veolia1 = new google.maps.Polygon({
		paths: [Veolia1Coords190211],
		strokeColor: "#000000",
		strokeOpacity: 0.2,
		strokeWeight: 1,
		fillColor: "#cc0000",		 
		fillOpacity: 0.13,			
		id: 1,		 
	});
	
	var Veolia2 = new google.maps.Polygon({
		paths: [Veolia2Coords190211],
		strokeColor: "#000000",
		strokeOpacity: 0.2,
		strokeWeight: 1,
		fillColor: "#ff8800",
		fillOpacity: 0.13,			
		id: 2,			 
	});
	
	var Veolia3 = new google.maps.Polygon({
		paths: [Veolia3_WestCoords190211, Veolia3Cords190211],
		strokeColor: "#000000",
		strokeOpacity: 0.2,
		strokeWeight: 1,
		fillColor: "#007e33",
		fillOpacity: 0.13,		
		id: "Standard rates",		
	});
	
	var Veolia4 = new google.maps.Polygon({
		paths: [Veolia4aCoords190211, Veolia4bCoords190211, Veolia4cCoords190211, Veolia4dCoords190211],
		strokeColor: "#000000",
		strokeOpacity: 0.2,
		strokeWeight: 1,		
		fillColor: "#304ffe",
		fillOpacity: 0.13,		
		id: "Standard rates",		
	});
	
  	var Veolia5 = new google.maps.Polygon({
		paths: [VeoliaPOACoords190211],
		strokeColor: "#000000",
		strokeOpacity: 0.2,
		strokeWeight: 1,		
		fillColor: "#FF6A00",
		fillOpacity: 0.11,		
		id: "POA",		
	});
	
	addZoneEventListeners(Veolia1);	
	addZoneEventListeners(Veolia2);
	addZoneEventListeners(Veolia3);
	addZoneEventListeners(Veolia4);
	addZoneEventListeners(Veolia5);*/
  	addZoneEventListeners(VeoliaCircle);
	
	function addZoneEventListeners(zone) {
		zone.setMap(Vmap);
		var zoneInfo = document.getElementById("Veolia-zone-info");
				
		google.maps.event.addListener(zone, "mouseover", function(event) {		
			zone.setOptions({fillOpacity: 0.3, strokeWeight: 2, strokeOpacity: 0.4});		
			toggleVisibility(zone, zoneInfo, "visible");
		});
		
		google.maps.event.addListener(zone, "mouseout", function(event) {
			zone.setOptions({fillOpacity: 0.13, strokeWeight: 1, strokeOpacity: 0.15});
			toggleVisibility(zone, zoneInfo, "hidden");
		});  
	}		
	
	function toggleVisibility(zone, zoneInfo, visibility) {
		zoneInfo.style.visibility = visibility;	
		if (visibility == "visible") {

              document.getElementById("Veolia-zone-info-name").innerText = "Veolia delivery: " + zone.id;
              zoneInfo.style.backgroundColor = zone.fillColor;
              zoneInfo.style.opacity = 1;
            
		} else {
			zoneInfo.style.opacity = 0;
		}
	}
  // Create the search box and link it to the UI element.
	var input = document.getElementById("map-search-box-veolia");
	var searchBox = new google.maps.places.SearchBox(input);
	Vmap.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

	// Bias the SearchBox results towards current map's viewport.
	Vmap.addListener("bounds_changed", function() {
		searchBox.setBounds(Vmap.getBounds());
	});

	var markers = [];
	
	// Listen for the event fired when the user selects a prediction and retrieve
	// more details for that place.
	searchBox.addListener('places_changed', function() {
		var places = searchBox.getPlaces();

		if (places.length == 0) {
			return;
		}

		// Clear out the old markers.
		markers.forEach(function(marker) {
			marker.setMap(null);
		});
		markers = [];

		// For each place, get the icon, name and location.
		var bounds = new google.maps.LatLngBounds();
		places.forEach(function(place) {
			if (!place.geometry) {
				console.log("Returned place contains no geometry");
				return;
			}
			
			var icon = {
				url: place.icon,
				size: new google.maps.Size(71, 71),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(17, 34),
				scaledSize: new google.maps.Size(25, 25)
			};

			// Create a marker for each place.
			markers.push(new google.maps.Marker({
				map: Vmap,
				icon: icon,
				title: place.name,
				position: place.geometry.location
			}));

			if (place.geometry.viewport) {
			  // Only geocodes have viewport.
			  bounds.union(place.geometry.viewport);
			} else {
			  bounds.extend(place.geometry.location);
			}
	  });
	  
	  Vmap.fitBounds(bounds);
	});  
}